/** @jsx jsx */
import { jsx, Heading } from 'theme-ui'
import SEO from "../components/SEO"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import { MDXProvider } from "@mdx-js/react"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { Link } from "gatsby"
import { Flex } from 'theme-ui'
import { HiOutlineClock } from 'react-icons/hi';
import { BsDot } from 'react-icons/bs';
import { CgListTree } from 'react-icons/cg';
import { IconContext } from "react-icons";



const IcoWrapper = ({Icon, title}) => {
  return  (<IconContext.Provider value={{
    size: '13px',
     style: { verticalAlign:'middle'},
      }}
     
     >
     <Icon {...{title: title}}/>
 </IconContext.Provider>)
}

const shortcodes = { Link } // Provide common components here

const components = {
  p: props => <p sx={{fontSize:2, }} {...props} />,
}

export default function PageTemplate({ data: { mdx } }) {
  return (
    <Layout>
      <SEO 
      description={mdx.frontmatter.title}
      title={mdx.frontmatter.title}/>


      <Heading as="h1"   variant="variant.title.article" >{mdx.frontmatter.title}</Heading>
      
        <Flex sx={{fontFamily: 'body', justifyContent: 'center', alignItems:'center',
         py:2, justifyItems:'center', color: 'subtxt',
         flexDirection:['row'], fontSize: '13px'}}>

            <IcoWrapper Icon={HiOutlineClock} title="Publication date" /> 
            <time sx={{pl:1, pr:2}} dateTime={mdx.frontmatter.isoDate}>{mdx.frontmatter.date}</time>

            <IcoWrapper Icon={CgListTree} title="Category" /> 
            <span sx={{px:1}}>{mdx.frontmatter.sub}</span>

            <IcoWrapper Icon={BsDot} title="Reading time" /> 
            <span sx={{px:1}}>{mdx.fields.readingTime.text}</span>


        </Flex>
      <MDXProvider components={mdx.frontmatter.lang ? components : {} }>
        <MDXRenderer>{mdx.body}</MDXRenderer>
      </MDXProvider>
    </Layout>
  )
}
export const pageQuery = graphql`
  query BlogPostQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        title
        date(formatString: "MMMM Do, YYYY")
        isoDate:date(formatString: "YYYY-MM-DD")
        sub
        lang
      }
      fields {
        slug
        readingTime {
        minutes,
        text
        }
      }
    }
  }
`